export default __webpack_public_path__ + "static/media/health_coach.0dc80514.svg";